import { ReactElement, ReactNode, useId } from "react";
import './input-checkbox.css'
import { clsx, inputOnKeyUp } from "../../functions.ts";

export default function InputCheckbox (props: {
	label: string,
	value: boolean,
  infoButton?: ReactNode,
  onChange: (value: boolean) => void,
}){
  const id = useId();
  return <div className={"input input-checkbox"}>
        <label className={"input__label"}></label>
        <div tabIndex={0} role="checkbox" aria-checked={props.value} aria-label={props.labe} className="input-checkbox__container"
         onClick={()=>{props.onChange(!(props.value || false))}}
         onKeyUp={(event)=>inputOnKeyUp(event, ()=>{props.onChange(!(props.value || false))})}
         >
          <div className={clsx("input-checkbox__box", props.value && "input-checkbox__box--active")}>
          <input inert className={"input-checkbox__input input"} id={id} type="checkbox" checked={props.value || false}/>
          </div>
          <label className={"input-checkbox__label"} htmlFor={id}><span dangerouslySetInnerHTML={{__html:props.label}}></span>{props.infoButton}</label>
        </div>
    </div>
}
